import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, getResources, WithPermission } from 'admin-on-rest';
import {USER_ROLE_TITLE} from "../../../util/util";
import './Menu.css';

// icons
import Logo from '../../images/logo.png';
import DashboardIcon from 'material-ui/svg-icons/action/dashboard';
import UserIcon from 'material-ui/svg-icons/social/group';
import DeviceIcon from 'material-ui/svg-icons/hardware/cast';

const permissions = [USER_ROLE_TITLE.ADMIN];

const Menu = ({ resources, onMenuTap, logout }) => (
  <div>
    <div className="menu-logo">
      <img src={Logo} alt="logo" />
      <span className="title">Pampett</span>
    </div>
    <WithPermission value={permissions}>
      <MenuItemLink to="/users" primaryText="Users" onClick={onMenuTap} leftIcon={<UserIcon />} />
      <MenuItemLink to="/devices" primaryText="Devices" onClick={onMenuTap} leftIcon={<DeviceIcon />} />
    </WithPermission>
    <MenuItemLink to="/" primaryText="Dashboard" onClick={onMenuTap} leftIcon={<DashboardIcon />} />
    {logout}
  </div>
);

const mapStateToProps = state => ({
  resources: getResources(state),
});

export default connect(mapStateToProps)(Menu);


// WEBPACK FOOTER //
// ./src/common/components/Menu/Menu.js